import { FC, ReactNode, useEffect, useState } from "react"
import Tooltip, { ITooltipProps, TooltipPlacement, TooltipTrigger } from "components/Tooltip/Tooltip"

export interface IInfoDropdownProps extends Pick<ITooltipProps, "content" | "isOpen" | "onOpen" | "onClose" | "disabled" | "minWidth" | "maxWidth" | "minHeight" | "maxHeight" | "forceKeepOpen" | "disableHide"> {
    label: ((isOpen: boolean) => ReactNode) | ReactNode
    placement?: TooltipPlacement
    trigger?: TooltipTrigger
}

const InfoDropdown: FC<IInfoDropdownProps> = ({
    label,
    placement,
    trigger = "click",
    isOpen: isOpenProp,
    onOpen,
    onClose,
    ...tooltipProps
}) => {
    const [isOpen, setIsOpen] = useState(isOpenProp || false)

    useEffect(() => {
        setIsOpen(isOpenProp || false)
    }, [isOpenProp])

    function handleOpen() {
        if (trigger === "click" && typeof isOpenProp === "undefined") {
            setIsOpen(true)
        }
        onOpen?.()
    }

    function handleClose() {
        if (trigger === "click" && typeof isOpenProp === "undefined") {
            setIsOpen(false)
        }
        onClose?.()
    }

    return (
        <Tooltip
            {...tooltipProps}
            key={isOpen ? "open" : "closed"}
            isOpen={trigger === "click" ? isOpen : undefined}
            onOpen={handleOpen}
            onClose={handleClose}
            placement={placement}
            trigger={trigger}
            delayHide={trigger === "hover" ? 300 : undefined}
            theme="light"
            arrow={false}
            contentPadding="0"
            forceHideCloseButton>
            {typeof label === "function"
                ? label(isOpen)
                : label
            }
        </Tooltip>
    )
}

export default InfoDropdown
